import './App.css';
import RouteContainer from "./router";
import { HashRouter as Router } from "react-router-dom";
var port;
window.addEventListener('message', function (event) {
  if (event.data == 'capturePort') {
    // capture port2 coming from the Dart side
    if (event.ports[0] != null) {
      // the port is ready for communication,
      // so you can use port.postMessage(message); wherever you want
      port = event.ports[0];
      // To listen to messages coming from the Dart side, set the onmessage event listener
      window.flutterMessageChannelPort = port;
      port.onmessage = function (event) {
        // event.data contains the message data coming from the Dart side 
        console.log(event.data);
      };
    }
  }
}, false);


function App() {
  return (
    <Router>
      <div className="App">
        <RouteContainer>
        </RouteContainer>
      </div>
    </Router>
  );
}

export default App;
